
const RED = new Set(['♥', '♦']);

/** A small playing card, e.g. <PlayingCard card="K♠" />. 'T' renders as 10. */
export default function PlayingCard({ card, size = 'md', className = '', style }) {
  const suit = card.slice(-1);
  const rank = card.slice(0, -1).replace('T', '10');
  const red = RED.has(suit);
  const sizes = {
    sm: 'w-[1.9em] h-[2.6em] text-[0.8rem] rounded-[0.35em]',
    md: 'w-[2.3em] h-[3.15em] text-[clamp(0.85rem,0.6rem+0.9*var(--u),1.6rem)] rounded-[0.4em]',
    lg: 'w-[2.4em] h-[3.3em] text-[clamp(1.1rem,0.7rem+1.6*var(--u),2rem)] rounded-[0.42em]',
  };

  return (
    <span
      className={`relative inline-flex shrink-0 flex-col items-center justify-center bg-[#F4F1EA] font-bold leading-none shadow-[0_1px_0_rgba(255,255,255,0.6)_inset,0_8px_18px_-10px_rgba(0,0,0,0.6)] ring-1 ring-black/10 ${red ? 'text-[#C2412F]' : 'text-[#141614]'} ${sizes[size]} ${className}`}
      style={style}
      aria-label={card}
    >
      <span className="tracking-[-0.06em]">{rank}</span>
      <span className="mt-[0.1em] text-[0.9em]">{suit}</span>
    </span>
  );
}
